import styled, { css } from "styled-components";
import Select from "react-select";
import { SwiperSlide } from "swiper/react";
import { textStyles } from "constant/useClass";
import check from "assets/images/common/check.svg";
import checkActive from "assets/images/common/check_a.svg";

const createFlexBox = ({
  $gap,
  $jus,
  $mar,
  $pad,
  $flex,
  $borB,
  $bTop,
  $over,
  $overX,
  $overY,
  $white,
  $align,
  $direct,
  $width,
  $shadow,
  $cursor,
  $height,
  $radius,
  $tAlign,
  $position,
  $flexWrap,
  $minWidth,
  $maxWidth,
  $maxHeight,
  $backColor,
}) => css`
  gap: ${$gap};
  flex: ${$flex};
  align-items: ${$align};
  flex-wrap: ${$flexWrap};
  justify-content: ${$jus};
  flex-direction: ${$direct};

  width: ${$width};
  min-width: ${$minWidth};
  max-width: ${$maxWidth};

  height: ${$height};
  max-height: ${$maxHeight};

  margin: ${$mar};
  padding: ${$pad};

  border-top: ${$bTop};
  border-bottom: ${$borB};
  border-radius: ${$radius};
  box-shadow: ${$shadow};

  text-align: ${$tAlign};
  background: ${$backColor};
  position: ${$position};

  overflow: ${$over};
  overflow-x: ${$overX};
  overflow-y: ${$overY};

  cursor: ${$cursor};
  white-space: ${$white};

  display: flex;
`;

const createPadBox = ({ $pad, $width }) => css`
  padding: ${$pad};
  width: ${$width};
`;

const createIcon = ({ $url, $bor, $width, $height, $trans, $radius, $minWidth }) => css`
  display: block;
  border: ${$bor};
  width: ${$width};
  min-width: ${$minWidth};
  height: ${$height};
  background: ${`url(${$url}) no-repeat center`};
  border-radius: ${$radius};
  cursor: pointer;
  &.active {
    background: ${$url};
    transform: ${$trans};
  }
`;

const createPositionBox = ({
  $position,
  $top,
  $bottom,
  $trans,
  $left,
  $right,
  $zIndex,
  $width,
  $pad,
  $dis,
  $jus,
  $align,
  $height,
  $backColor,
}) => css`
  position: ${$position};
  top: ${$top};
  bottom: ${$bottom};
  left: ${$left};
  right: ${$right};
  transform: ${$trans};
  z-index: ${$zIndex};
  width: ${$width};
  padding: ${$pad};
  height: ${$height};
  display: ${$dis};
  align-items: ${$align};
  justify-content: ${$jus};
  background-color: ${$backColor ? $backColor : ""};
`;

const IconLink = styled.span`
  ${createIcon}
`;

const FlexBox = styled.div`
  ${createFlexBox}
`;

const Column = styled(FlexBox)`
  flex-direction: column;
`;
const Row = styled(FlexBox)`
  &.not-login {
    opacity: 0.4;
  }
`;

const Between = styled(FlexBox)`
  align-items: ${(props) => props.$align ?? "center"};
  justify-content: space-between;
`;

const Center = styled(FlexBox)`
  align-items: center;
  justify-content: center;
`;

const PadBox = styled.div`
  ${createPadBox}
`;

const PositionBox = styled.div`
  ${createPositionBox}
`;

const ContentArea = styled.div`
  position: relative;

  width: 100%;
  height: 100%;
`;

const Dimmed = styled.div`
  background-color: var(--c-opacity);
  backdrop-filter: blur(var(--dim));
  position: fixed;
  top: 0;
  left: 0;
  padding: ${(props) => props.$pad};
  width: 100%;
  height: 100%;
  z-index: 10010;
`;

const SectionBox = styled.section.attrs({ className: "section" })`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Slide = styled(SwiperSlide)`
  width: ${(props) => (props.$width ? props.$width : "fit-content !important")};
  height: ${(props) => (props.$height ? props.$height : "fit-content !important")};
  max-width: ${(props) => (props.$maxWidth ? props.$maxWidth : "fit-content !important")};
  &.h-a:hover {
    opacity: 0.4;
  }
`;

const Img = styled.img`
  width: ${(props) => props.$width};
  height: auto;
  cursor: pointer;
`;

const GameInfoBox = styled.div`
  width: 100%;
  padding: ${(props) => (props.$pad ? props.$pad : "14px 16px")};
`;

const GameInfoBoxTab = styled.div`
  width: 100%;
  padding: ${(props) => (props.$pad ? props.$pad : "14px 9px 14px 16px")};
`;

const Empty = styled.div`
  text-align: ${(props) => props.$tAlign};
  width: ${(props) => props.$width};
  height: ${(props) => props.$height};
  padding: ${(props) => props.$pad};
`;

const createLineSection = ({ $pad, $borT, $borL, $borR, $borB, $width, $height, $radius }) => css`
  padding: ${$pad};
  border-top: ${$borT};
  border-left: ${$borL};
  border-right: ${$borR};
  border-bottom: ${$borB};
  border-radius: ${$radius};
  height: ${$height};

  width: ${$width ? $width : "fit-content"};
`;

const LineSection = styled.div`
  ${createLineSection}
`;

const createWarningBox = ({
  $dis,
  $gap,
  $jus,
  $mar,
  $pad,
  $flex,
  $align,
  $direct,
  $width,
  $shadow,
  $height,
  $radius,
  $tAlign,
  $flexWrap,
  $minWidth,
  $maxWidth,
  $maxHeight,
}) => css`
  gap: ${$gap};
  flex: ${$flex};
  display: ${$dis};
  align-items: ${$align};
  flex-wrap: ${$flexWrap};
  justify-content: ${$jus};
  flex-direction: ${$direct};

  width: ${$width};
  min-width: ${$minWidth};
  max-width: ${$maxWidth};

  height: ${$height};
  max-height: ${$maxHeight};

  margin: ${$mar};
  padding: ${$pad};

  box-shadow: ${$shadow};
  border-radius: ${$radius};

  text-align: ${$tAlign};
  background-color: var(--c-rOpacity);
`;

const WarningBox = styled.div`
  ${createWarningBox}
`;

const MyPageLayout = styled.div`
  width: 100%;
  max-width: ${(props) => props.$maxWidth ?? "500px"};
  padding-top: ${(props) => props.$padT ?? "40px"};
  padding: ${(props) => props.$pad};

  margin: 0 auto;
  overflow-x: ${(props) => props.$overX};

  display: ${(props) => props.$dis};
  align-items: ${(props) => props.$align};
  justify-content: ${(props) => props.$jus};

  @media (max-width: 1100px) {
    max-width: 100%;
    padding-top: 32px;
  }

  @media (max-width: 700px) {
    max-width: 100%;
  }
`;

const NotMenuLayout = styled.div`
  width: 100%;
  max-width: ${(props) => props.$maxWidth ?? "500px"};
  padding: ${(props) => props.$pad};

  margin: 0 auto;
  overflow-x: ${(props) => props.$overX};

  display: ${(props) => props.$dis};
  align-items: ${(props) => props.$align};
  justify-content: ${(props) => props.$jus};

  @media (max-width: 700px) {
    max-width: 100%;
  }
`;

const GrayCon = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.$gap ?? "10px"};

  padding: ${(props) => props.$pad ?? "12px 16px"};
  border-radius: ${(props) => props.$radius ?? "12px"};
  background-color: var(--c-gray-700);

  align-items: ${(props) => props.$align};

  &.ho-ac {
    cursor: pointer;
    &:hover {
      background-color: var(--c-gray-600);
    }
  }
`;

const GrayConRowDrag = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.$gap ?? "10px"};

  padding: ${(props) => props.$pad ?? "12px 16px"};
  border-radius: ${(props) => props.$radius ?? "12px"};
  background-color: var(--c-gray-700);

  align-items: ${(props) => props.$align};

  &.ho-ac {
    cursor: pointer;
    &:hover {
      background-color: var(--c-gray-600);
    }
  }

  overflow-x: auto;
`;

const BorderBGrayCon = styled(GrayCon)`
  border-bottom: 1px solid var(--c-gray-600);
`;


const createActionBtn = ({ $pad, $mar, $size, $font, $line, $width, $tAlign, $radius, $backColor, $hoverBackColor, $fontWeight }) => css`
  color: var(--c-white);
  background: ${$backColor || "var(--c-gray-600)"};
  width: ${$width};
  margin: ${$mar};

  padding: ${$pad || "0 12px"};

  width: ${$width};
  white-space: nowrap;
  text-align: ${$tAlign};
  &:hover {
    background-color : ${$hoverBackColor}
  }
  font-size: ${$size};
  font-family: ${$font};
  line-height: ${$line};
  border-radius: ${$radius};
  font-weight: ${$fontWeight};
`;

const createTabBtn = ({
  $gap,
  $pad,
  $size,
  $font,
  $line,
  $color,
  $white,
  $width,
  $height,
  $radius,
  $position,
  $top,
  $left,
  $right,
  $minWidth,
  $minHeight,
  $backColor,
}) => css`
  width: ${$width};
  min-width: ${$minWidth};

  padding: ${$pad};
  position: ${$position};
  top: ${$top};
  left: ${$left};
  right: ${$right};

  height: ${$height};
  min-height: ${$minHeight};
  white-space: ${$white};
  color: ${$color};
  border-radius: ${$radius};
  background-color: ${$backColor};

  font-size: ${$size};
  font-family: ${$font};
  line-height: ${$line};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${$gap};

  &:disabled {
    opacity: 0.4;
  }

  &:hover {
    & > svg path {
      fill: var(--c-white);
    }
    & > span,
    p {
      color: var(--c-white);
    }
  }
`;

const createPGradient = ({
  $mar,
  $pad,
  $size,
  $font,
  $line,
  $over,
  $bgc,
  $color,
  $width,
  $height,
  $tAlign,
  $radius,
  $minWidth,
  $maxWidth,
  $minHeight,
}) => css`
  width: ${$width ? $width : "100%"};

  padding: ${$pad};

  height: ${$height};
  min-height: ${$minHeight};
  text-align: ${$tAlign};
  max-width: ${$maxWidth};
  min-width: ${$minWidth || $width};

  white-space: nowrap;
  background: ${$bgc || "var(--c-pGradient)"};
  border-radius: ${$radius};

  font-size: ${$size};
  font-family: ${$font ? $font : "var(--f-subB)"};
  color: ${$color ? $color : "var(--c-white)"};
  line-height: ${$line};
  margin: ${$mar};

  overflow: ${$over};

  &:disabled {
    opacity: 0.4;
  }
`;

const ActionBtn = styled.button`
  ${createActionBtn}
`;

const TabBtn = styled.button`
  ${createTabBtn}
`;

const P_GradientBtn = styled.button`
  ${createPGradient}
`;

const P_GradientBox = styled.div`
  ${createPGradient}
`;

const ContentSwap = styled.a`
  width: 100%;
  padding: 10px 0;
  text-align: center;

  border-radius: 30px;
  background-color: var(--c-black);

  color: var(--c-gray-300);
  font-size: var(--s-title);
  font-family: var(--f-title);
  line-height: var(--l-title);

  &.active {
    color: var(--c-white);
    background-color: var(--c-gray-700);
  }

  @media (max-width: 700px) {
    font-size: var(--s-sub);
    font-family: var(--f-subB);
    line-height: var(--l-sub);
  }
`;

const CashPlusBtn = styled.button`
  width: 100%;
  padding: 6px 0;
  text-align: center;
  color: var(--c-white);

  border-radius: 12px;
  border: 1px solid var(--c-gray-600);
  background-color: var(--c-gray-700);
`;

const ResetBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 32px;
  min-height: 32px;

  border-radius: 12px;
  background: var(--c-gray-700);
  border: 1px solid var(--c-gray-600);
`;

const BorderBtn = styled.button`
  padding: ${(props) => props.$pad ?? "6px 10px"};
  height: fit-content;
  display: ${(props) => props.$dis};
  background: ${(props) => props.$backColor};
  border-radius: ${(props) => props.$radius ?? "12px"};
  border: ${(props) => props.$bor ?? "1px solid var(--c-gray-500)"};
`;

const createInput = ({ $size, $font, $line, $height, $border, $backColor, $maxWidth, $tAlign, $placeColor }) => css`
  width: 100%;
  text-align: ${$tAlign};
  height: ${$height ? $height : "fit-content"};
  max-width: ${$maxWidth ? $maxWidth : ""};
  border: ${$border ? $border : "none"};
  background-color: ${$backColor ? $backColor : "transparent"};
  padding: 0;
  font-family: ${$font};
  font-size: ${$size ?? "var(--s-sub)"};
  line-height: ${$line ?? "var(--l-sub)"};

  color: var(--c-white);

  &::placeholder {
    color: ${$placeColor || "var(--c-gray-300)"};
  }
  
  &:-webkit-autofill {
    box-shadow: 0 0 0px 1000px ${$backColor || "transparent"} inset !important; /* 내부 그림자 */
    -webkit-text-fill-color: var(--c-white) !important; 
    transition: background-color 0s ease-in-out, color 0s ease-in-out !important;
  }
`;

const Input = styled.input`
  ${createInput}
`;

const CheckInput = styled.input.attrs({ type: "checkbox" })`
  cursor: pointer;
  appearance: none;
  margin: ${(props) => props.margin || "0 !important"};
  width: 15px !important;
  height: 15px !important;
  background: url(${check}) no-repeat center;

  &:checked {
    background: url(${checkActive}) no-repeat center;
  }
  &[disabled] {
    opacity: 0.4;
    cursor: default;
  }
  &[disabled] + label {
    opacity: 0.4;
    cursor: default;
  }
`;

const CheckRadio = styled.input.attrs({ type: "radio" })`
  cursor: pointer;
  margin: ${(props) => props.margin || "0 0 0 !important"};
  width: 20px !important;
  height: 20px !important;
  background: url(${check}) no-repeat center;

  &:checked {
    background: url(${checkActive}) no-repeat center;
  }
  &[disabled] {
    opacity: 0.5;
  }
  &[disabled] + label {
    opacity: 0.5;
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  height: 100%;
  text-align: start;

  resize: none;
  line-height: var(--l-sub);
  background-color: transparent;
  border: none;
  padding: 0;

  color: var(--c-white);

  &::placeholder {
    color: var(--c-gray-300);
  }
`;

const Selects = styled(Select).attrs({ className: "select-box" })`
  width: 100%;
  border-radius: 12px;
  
  .css-b62m3t-container {
    width: 100%;
    height: 40px;
  }

  .css-1s5swe7-control,
  .css-1yxm7j6-control,
  .css-xhp73o-control {
    width: 100%;
    border-color: none !important;
    box-shadow: none;
    border: none !important;
  }

  .css-1fdsijx-ValueContainer,
  .css-3w2yfm-ValueContainer {
    width: 100%;
    padding: 0;
    align-items: center;
  }

  .css-1p3m7a8-multiValue {
    display: none;
  }
  .css-1xc3v61-indicatorContainer {
    display: none;
  }
  .css-1jqq78o-placeholder {
    font-size: ${(props) => props.size || "var(--s-sub)"};
    line-height: ${(props) => props.line || "var(--l-sub)"};
    font-family: ${(props) => props.font || "var(--f-sub)"};
    color: ${(props) => props.color || "var(--c-gray-300)"};
    white-space: nowrap;
    margin: 0;
  }
  .css-1dimb5e-singleValue {
    font-size: ${(props) => props.size || "var(--s-sub)"};
    line-height: ${(props) => props.line || "var(--l-sub)"};
    font-family: ${(props) => props.font || "var(--f-sub)"};
    color: ${(props) => props.selectColor || "var(--c-gray-300)"};
    white-space: nowrap;
    margin: 0;
  }

  .css-1u9des2-indicatorSeparator {
    display: none;
  }
  .css-qbdosj-Input {
    margin: 0;
    padding: 0;
  }

  .css-15lsz6c-indicatorContainer {
    display: none;
  }
  .react-select__option {
    padding: 8px;
    background-color: var(--c-gray-700); /* option 배경색 */
    font-family: var(--f-sub);
  }
  .react-select__option--is-selected {
    color: white; /* 클릭된 option 텍스트 색상 */
    font-family: var(--f-sub);
  }

  .css-b62m3t-container--is-disabled {
    background-color: #e0e0e0; // 비활성화 배경색
    color: #9e9e9e; // 비활성화 글자색
    cursor: not-allowed; // 마우스 포인터
  }

  @media (max-width: 700px) {
    width: 100%;
  }
`;

const createInputCon = ({ $width, $mar, $pad, $radius, $height, $backColor, $cursor }) => css`
  width: ${$width ? $width : "100%"};
  padding: ${$pad};
  margin: ${$mar};
  border-radius: ${$radius};
  height: ${$height ? $height : "fit-content"};
  background-color: ${$backColor || "var(--c-gray-700)"};
  cursor : ${$cursor};
  &.not-value {
    border: 1px solid var(--c-red);
  }
  &:focus-within {
    border: 1px solid var(--c-purple);
  }
`;

const InputCon = styled.div.attrs({ className: "input-con" })`
  ${createInputCon}
`;


const createTextBox = ({
  $dis,
  $color,
  $weight,
  $tAlign,
  $white,
  $width,
  $minWidth,
  $op,
  $over,
  $textDeco,
  $pad,
  $radius,
  $mask,
  $border,
  $shadow,
  $mar,
  $class,
  $cursor,
  $backColor,
  $html,
  $fontSize
}) => {
  const classes = Array.isArray($class) ? $class : [$class];

  // 각 클래스에 해당하는 스타일을 합치기
  const combinedStyles = classes.map((cls) => textStyles[cls]).join(" ");
  const styles = ` 
    color: ${$color};

    font-weight: ${$weight};

    width: ${$width};
    min-width: ${$minWidth};

    text-align: ${$tAlign};
    white-space: ${$white};
    opacity: ${$op};
    overflow: ${$over};
    text-decoration: ${$textDeco};

    margin: ${$mar};
    padding: ${$pad};
    border-radius: ${$radius};
    background-color: ${$backColor};
    border: ${$border};
    cursor: ${$cursor};
    font-size: ${$fontSize};
    mask-image: ${$mask};
    -webkit-mask-image: ${$mask};
    box-shadow: ${$shadow};
    word-break: break-all;
    display: ${$dis || "inline-block"};

    &.ho-un {
      &:hover {
        text-decoration: underline;
      }
    }

    ${combinedStyles}
  `;

  return $html ? css`p{${styles}` : css`${styles}`
};

const createWarningMsg = ({ $padT, $top, $size, $font, $line, $position }) => css`
  font-size: ${$size ? $size : " var(--s-caption)"};
  font-family: ${$font ? $font : " var(--f-caption)"};
  line-height: ${$line ? $line : " var(--l-caption)"};

  top: ${$top};
  position: ${$position};
  color: var(--c-red);
  display: inline-block;
  padding-top: ${$padT ?? "8px"};
`;

const createSuccessMsg = ({ $mar, $top, $size, $font, $line, $position }) => css`
  font-size: ${$size ? $size : " var(--s-caption)"};
  font-family: ${$font ? $font : " var(--f-caption)"};
  line-height: ${$line ? $line : " var(--l-caption)"};
  margin: ${$mar};
  top: ${$top};
  display: inline-block;
  position: ${$position};
  color: var(--c-blue);
`;

const TextBox = styled.span`
  ${createTextBox}
  white-space: pre-wrap;
`;

const EllipsisText = styled.span`
  ${createTextBox}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;

  font-family: var(--f-subB);
`

const WarningMsg = styled.span.attrs({ className: "error" })`
  ${createWarningMsg}
`;

const SuccessMsg = styled.span.attrs({ className: "Success" })`
  ${createSuccessMsg}
`;

const Label = styled.label`
  white-space: nowrap;
  color: var(--c-gray-900);
  font-size: var(--s-sub);
  line-height: var(--l-sub);
`;

const createA = ({
  $dis,
  $color,
  $weight,
  $tAlign,
  $white,
  $width,
  $minWidth,
  $op,
  $over,
  $textDeco,
  $pad,
  $radius,
  $mask,
  $border,
  $shadow,
  $mar,
  $class,
  $cursor,
}) => {
  const classes = Array.isArray($class) ? $class : [$class];

  // 각 클래스에 해당하는 스타일을 합치기
  const combinedStyles = classes.map((cls) => textStyles[cls]).join(" ");
  return css`
    color: ${$color};

    font-weight: ${$weight};

    width: ${$width};
    min-width: ${$minWidth};

    text-align: ${$tAlign};
    white-space: ${$white};
    opacity: ${$op};
    overflow: ${$over};
    text-decoration: ${$textDeco};

    margin: ${$mar};
    padding: ${$pad};
    border-radius: ${$radius};
    border: ${$border};
    cursor: ${$cursor};

    mask-image: ${$mask};
    -webkit-mask-image: ${$mask};
    box-shadow: ${$shadow};
    display: ${$dis || "inline-block"};
    ${combinedStyles}
  `;
};

const A = styled.a`
  ${createA}
`;

const RequiredText = styled(TextBox)`
  position: relative;
  width: fit-content;

  color: var(--c-white);
  font-size: var(--s-caption);

  padding-bottom: 8px;

  &::after {
    content: "";
    position: absolute;
    width: 4px;
    height: 4px;
    border-radius: 999px;
    top: 0px;
    right: -10px;
    background-color: var(--c-red);
  }
`;


const MainLayout = styled.main`
  min-height: 100vh;
  position: relative;
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 20px;
  margin-left: 266px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &.slide {
    margin-left: 97px;
    @media (max-width: 700px) {
      margin-left: 0;
    }

    .menu-arrow,
    .menu-group {
      display: none;
    }
  }

  @media (max-width: 1280px) {
    margin-left: 97px;
  }

  @media (max-width: 850px) {
    padding-right: 20px;
  }

  @media (max-width: 700px) {
    padding: 0;
    margin-left: 0;
  }

  ${(p) =>
    p.$grandMain &&
    css`
      margin-left: 0;
      padding: 0;
      justify-content: flex-start;
      align-items: stretch;
    `}
`;

const ContentWrap = styled(Column)`
  width: 100%;
  flex: 1;
`;

const Article = styled.article`
  width: 100%;
  height: 100%;
  flex: 1;
  position: relative;
  max-width: 1574px;
  min-height: calc(100vh - 120px);

  padding: 28px;
  border-radius: 24px;
  background: var(--c-gray-800);

  margin: 0 auto;
  display: flex;
  flex-direction: column;

  @media (max-width: 700px) {
    margin-top: 0px;
    border-radius: 0px;
  }

  ${(p) =>
    p.$grandMain &&
    css`
      max-width: none;
      min-height: auto;
      padding: 0;
      border-radius: 0;
      background: transparent;
    `}
`;

export {
  ContentArea,
  Img,
  IconLink,
  Slide,
  Empty,
  Dimmed,
  PadBox,
  FlexBox,
  Column,
  Row,
  Between,
  Center,
  WarningBox,
  SectionBox,
  PositionBox,
  GameInfoBox,
  GameInfoBoxTab,
  LineSection,
  GrayCon,
  MyPageLayout,
  NotMenuLayout,
  BorderBGrayCon,
  GrayConRowDrag,
  ActionBtn,
  TabBtn,
  P_GradientBtn,
  ResetBtn,
  ContentSwap,
  CashPlusBtn,
  BorderBtn,
  P_GradientBox,
  Input,
  Selects,
  CheckInput,
  Textarea,
  CheckRadio,
  InputCon,
  A,
  Label,
  TextBox,
  WarningMsg,
  SuccessMsg,
  RequiredText,
  EllipsisText,
  ContentWrap,
  MainLayout,
  Article,
};
